import module from 'empresa/module.js'

export default class EmpresaConfiguracionRegistrosPatronalesMigrarColaboradoresService {
  constructor ($http) {
    this.$http = $http
  }

  get (empresaId, registroPatronalId) {
    return this.$http.get('/api/empresa/configuracion/registros-patronales/migrar/colaboradores', {
      params: {empresaId, registroPatronalId}
    })
  }
}

module.service('EmpresaConfiguracionRegistrosPatronalesMigrarColaboradores', EmpresaConfiguracionRegistrosPatronalesMigrarColaboradoresService)



// WEBPACK FOOTER //
// ./src/empresa/services/Empresa/Configuracion/RegistrosPatronales/Migrar/Colaboradores.js